import React from 'react';

import { Tab, Tabs } from '@mui/material';

interface ExtranetApprovalsTabsProps {
  activeTab: number;
  onChange: (tab: number) => void;
}

export default function ExtranetApprovalsTabs({ activeTab, onChange }: ExtranetApprovalsTabsProps) {
  return (
    <Tabs
      value={activeTab}
      onChange={(_, value) => onChange(value)}
      sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
    >
      <Tab label="Pending approvals" />
      <Tab label="Homes & Villas pending" />
      <Tab label="History" />
    </Tabs>
  );
}
